import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

export interface BreadcrumbItem {
    label: string;
    path: string;
    content?: React.ReactNode;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    variant?: 'default' | 'pet' | 'asset';
    badges?: string[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, variant = 'default', badges = [] }) => {
    if (variant === 'pet' || variant === 'asset') {
        const current = items[items.length - 1];
        const backItem = items.length > 1 ? items[items.length - 2] : undefined;
        const visibleBadges = badges.filter((badge) => badge.trim().length > 0);

        return (
            <div className="breadcrumb breadcrumb-asset">
                {backItem && (
                    <Link to={backItem.path} className="breadcrumb-back" aria-label={`Back to ${backItem.label}`}>
                        <span aria-hidden="true">&larr;</span>
                    </Link>
                )}
                <span className="breadcrumb-asset-name">{current?.label || ''}</span>
                {visibleBadges.map((badge) => (
                    <span className="breadcrumb-asset-badge" key={badge}>{badge}</span>
                ))}
            </div>
        );
    }

    return (
        <div className="breadcrumb">
            {items.map((item, index) => (
                <React.Fragment key={item.path}>
                    {index > 0 && <span className="breadcrumb-separator">›</span>}
                    {index === items.length - 1 ? (
                        item.content ?? <span className="breadcrumb-current">{item.label}</span>
                    ) : (
                        <Link to={item.path} className="breadcrumb-link">
                            {item.label}
                        </Link>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Breadcrumb;